       
        function CallSmallCase(TranID, Token, callback, errorCallback) {    
            // debugger        
            const gatewayInstance = new window.scDK({
                // ! Use valid gateway name here
                gateway: "bajajcapital-mf", //"<gateway_name>",
                /*
                 * ! Use valid auth token
                 * Details - https://developers.gateway.smallcase.com/docs/getting-started#broker-identification
                 */
                smallcaseAuthToken: '' + Token + '',
                config: {
                    // Should allow after market orders?
                    amo: true
                }
            })

            gatewayInstance.triggerTransaction({
                // ! Use valid transactionId here
                
                transactionId: '' + TranID + ''
            })
            .then(txnResponse => {
                // debugger
                callback();
                //GetImportedData($('#<%=txtpanumber.ClientID%>').val());
                
                /*
                * Gateway flow ended after order placement
                * Response structure & example - https://developers.gateway.smallcase.com/docs/transaction-response
                */
            })
            .catch(err => {
                // debugger
                /*
                * Gateway flow ended before order placement
                * (user closed/cancelled the SDK, or the transaction errored).
                * Possible errors - https://developers.gateway.smallcase.com/docs/transaction-errors
                */
                if (typeof errorCallback === 'function') {
                    errorCallback(err);
                }
            });
        }